// extracted by mini-css-extract-plugin
export default {"card":"adjust-coverage-section-module__card--Qzv","header":"adjust-coverage-section-module__header--ItX","fields":"adjust-coverage-section-module__fields--iS2"};